<template>
  <v-progress-circular v-if="items && items.length" :value="myValue" :rotate="myRotation" :color="items[0].color" :size="radius * 2" :width="radius - myInnerRadius">
    <v-container v-if="!hideValues">
      <v-layout row justify-center align-center>
        <v-flex :style="myLabelStyle" shrink>
          <div>{{ items[0].value }}</div>
        </v-flex>
      </v-layout>
    </v-container>
    <donut-chart v-if="childProps.items.length" v-bind="childProps"><slot /></donut-chart>
    <v-progress-circular v-else>
      <slot />
    </v-progress-circular>
  </v-progress-circular>
</template>

<script>
  const toRadians = angle => angle * (Math.PI / 180);

  export default {
    props: {
      items: {
        type: Array,
        default: () => []
      },
      allItems: {
        type: Array,
        default: () => null
      },
      rotate: {
        type: Number,
        default: -90
      },
      radius: {
        type: Number,
        default: 100
      },
      innerRadius: {
        type: Number,
        default: null
      },
      labelRadius: {
        type: Number,
        default: null
      },
      hideValues: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      myValue() {
        return 100 / this.total * this.items[0].value
      },
      myRotation() {
        return this.rotate || 0;
      },
      myLabelRadius() {
        return this.labelRadius || (this.radius + this.myInnerRadius) / 2;
      },
      myInnerRadius() {
        return this.innerRadius == null ? this.radius * 0.6 : this.innerRadius
      },
      myLabelStyle() {
        const ang = toRadians((this.myRotation + this.childRotation) / 2);
        return {
          position: 'relative',
          top: `${this.myLabelRadius * Math.sin(ang)}px`,
          left: `${this.myLabelRadius * Math.cos(ang)}px`,
          color: 'black'
        }
      },
      childProps() {
        return {
          ...this.$props,
          items: (this.items && this.items.length) ? this.items.slice(1) : [],
          allItems: this.allItems || this.items,
          rotate: this.childRotation
        };
      },
      childRotation() {
        return this.myRotation + 360 / this.total * this.items[0].value
      },
      total() {
        if (this.allItems && this.allItems.length) {
          return this.allItems.reduce((a, i) => i.value + a, 0);
        } else {
          return this.items.reduce((a, i) => i.value + a, 0);
        }
      }
    }
  }
</script>

<style scoped>
  .v-progress-circular /deep/ .v-progress-circular__underlay {
    stroke: rgba(0,0,0,0);
  }
  .container {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    padding: 0;
    margin: 0;
  }
</style>
